export type ExplorerCountsRefresh = "broadcast" | "timer"

export const EXPLORER_COUNTS_REFRESH: ExplorerCountsRefresh = "timer"

export const EXPLORER_COUNTS_REFETCH_MIN_MS = 25_000

export const EXPLORER_COUNTS_REFETCH_MAX_MS = 35_000

export const isExplorerCountsQueryKey = (
    queryKey: readonly unknown[]
): boolean => {
    const [path] = queryKey
    return (
        Array.isArray(path) &&
        path[0] === "workspaceDoc" &&
        path[1] === "getExplorerViewCounts"
    )
}

export const pickExplorerCountsRefetchIntervalMs = ({
    random,
}: {
    random: number
}): number =>
    Math.round(
        EXPLORER_COUNTS_REFETCH_MIN_MS +
            random *
                (EXPLORER_COUNTS_REFETCH_MAX_MS -
                    EXPLORER_COUNTS_REFETCH_MIN_MS)
    )
